import React from "react";
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import payment300 from '../assets/payment300.png';
import './CSS/ImageConverter.css';

const PaymentQR300 = () => {
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <img className="logo" src={logo} alt="Logo" />
      <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
        <img src={payment300} alt="Payment Slip" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
      </div>
      <br />
      <div><Link to='/uploadslip300'>Upload Your Payment Slip</Link></div>
      <br />
      <div>Powered by</div>
      <img className="logo2" src={logo2} alt="Logo 2" />
      <div>New Wave Consulting Group</div>
    </div>
  );
};

export default PaymentQR300;
